export const ContactSourceEnum = Object.freeze({
    ADDRESS_BOOK_CONTACT: "AddressBookContact",
    USER: "User",
});
